import { Formik, type FormikConfig, type FormikValues } from 'formik';

import { YupSpecProvider } from './YupSpecProvider';

export type YupFormikProps<Values extends FormikValues> = Omit<
  FormikConfig<Values>,
  'validationSchema'
> & {
  isReadOnly?: boolean;
  isDisabled?: boolean;
  validationSchema?: unknown;
};

export function YupFormik<Values extends FormikValues>({
  isDisabled,
  isReadOnly,
  validationSchema,
  ...props
}: YupFormikProps<Values>) {
  return (
    <YupSpecProvider isDisabled={isDisabled} isReadOnly={isReadOnly} schema={validationSchema}>
      <Formik {...props} validationSchema={validationSchema} />
    </YupSpecProvider>
  );
}
